<div class="grid-container">
  <!-- Country Dropdown -->
  <div class="column ps-0">
    <div class="input-container">
      <label for="city" class="label">Country<span *ngIf="isRequired">*</span></label>
      <div>
        <app-countries-dropdown-input [(ngModel)]="value.country"
          (selected)="selectCountry($event)"></app-countries-dropdown-input>
      </div>
    </div>
  </div>

  <!-- State Input -->
  <div class="column">
    <div class="input-container">
      <label for="state" class="label">State<span *ngIf="isRequired">*</span></label>
      <div>
        <div class="location-input-container">
          <input class="input input-text" placeholder="Enter state" (ngModelChange)="fetchStatePredictions($event)"
            [(ngModel)]="value.state" [disabled]="!value.country" />
          <div *ngIf="showStateResults" class="results-main-container">
            <div *ngFor="let prediction of statePredictions" class="result-item" (click)="selectState(prediction)">
              {{ prediction.terms[0].value }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- City Input -->
  <div class="column">
    <div class="input-container">
      <label for="location" class="label">City<span *ngIf="isRequired">*</span></label>
      <div>
        <div class="location-input-container">
          <input class="input input-text" placeholder="Enter city" (ngModelChange)="fetchCityPredictions($event)"
            [(ngModel)]="value.city" [disabled]="!value.country || !value.state" />
          <div *ngIf="showCityResults" class="results-main-container">
            <div *ngFor="let prediction of cityPredictions" class="result-item" (click)="selectCity(prediction)">
              {{ prediction.terms[0].value }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Zip Code Input -->
  <div class="column pe-0">
    <div class="input-container">
      <label for="zipCode" class="label">Zip Code<span *ngIf="isRequired">*</span></label>
      <div>
        <input type="text" class="input input-text" [(ngModel)]="value.zipCode" placeholder="E.g., 500055 or ABC-123" />
      </div>
    </div>
  </div>
</div>